import React from 'react';

class Footer extends React.Component {

  render() {
    return (
        <div className="layout-footer p-grid p-justify-center p-align-center p-nogutter p-component">
          <div className="p-col">
            &copy; TapSee 2021
          </div>
        </div>
    )
  }
}

export default Footer;
